import { IDynamicNavItem } from '@topshots/core-models';
import { topshotsAPI } from './api';

const navAPI = topshotsAPI.injectEndpoints({
  endpoints: (builder) => ({
    getNav: builder.query<IDynamicNavItem[], void>({
      query: (request) => 'nav',
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.map(({ title }) => ({
                type: 'Navs' as const,
                id: title,
              })),
              { type: 'Navs', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Navs', id: 'PARTIAL-LIST' }],
    }),
  }),
});

export const { useGetNavQuery } = navAPI;
